module.exports = __webpack_public_path__ + "static/media/FM_EU_Complaints_Procedure_For_Clients_March_2025.e31fffa7.pdf";